import { useContext } from 'react';
import './SidebarOption.css';
// import AddPopupContext from '../../context/AddPopupContext';
import { AddPopupContext } from '../../context/AddPopupContext';
import { useNavigate } from 'react-router-dom';

const SidebarOption = ({
  imageSrc,
  expandImg,
  optionName,
  subOptions,
  plusImg,
  isActive,
  activeSubOption,
  onMainOptionClick,
  onSubOptionClick,
  showPlusIconForSubpoints,
  showPlusIconForMainOption,
  isMinimized,
}) => {
  const { openPopup } = useContext(AddPopupContext);
  const navigate = useNavigate();


// In SidebarOption component
const handlePlusClick = (e, subOption = activeSubOption) => {
  e.stopPropagation();

  if (subOption === 'Recipient Groups') { // Make sure this matches exactly
    navigate('/add-recipient'); // This should match your route
  } else {
    openPopup(subOption);
  }
};
  const shouldShowPlusIcon = (subOption) => {
    return (
      showPlusIconForSubpoints &&
      activeSubOption === subOption &&
      [ 'Our Plans', 'Features','Countries', 'States', 'Currencies', 'FAQ\'s', 'FAQ Categories', 'User Roles', 'Taxes','Languages','Translations', 'Category', 'Internal User roles','Recipient Groups','Email Configuration'].includes(subOption)
    );
  };

  return (
    <div className="menu-item-container">
  <div
    className={`menu-item-header ${isActive ? (subOptions ? 'active-main-with-sub dk-lt-gray' : 'active-main-no-sub black') : ''}`}
    onClick={() => onMainOptionClick(optionName, '', subOptions)}
  >
        <img src={`/assets/${imageSrc}.png`} className="sidebar-option-img" alt={optionName} />
        {!isMinimized && <span className="option-name">{optionName}</span>}

        {subOptions && subOptions.length > 0 && !isMinimized && (
          <img 
            src={`/assets/${expandImg}.png`} 
            className={`sidebar-expand-img ${isActive ? 'rotate-down' : ''}`} 
            alt="expand" 
          />
        )}
        
        {showPlusIconForMainOption && isActive && !isMinimized && (
          <img
            src={`/assets/${plusImg}.png`}
            className="sidebar-plus-img"
            alt="plus"
            onClick={(e) => handlePlusClick(e, optionName)} // or subOptions?.[0]
          />
        )}

      </div>

      {isActive && subOptions && subOptions.length > 0 && (
        <div className="sub-options">
          {subOptions.map((subOption, index) => (
            <div
              key={index}
              className={`menu-item-sub ${activeSubOption === subOption ? 'active-sub-option black' : ''}`}
              onClick={() => onSubOptionClick(subOption)}
            >
              <span className={`option-name  ${activeSubOption === subOption ? 'black' : 'dk-lt-gray'}`}>
                {subOption}
              </span>
              {shouldShowPlusIcon(subOption) && (
                <img src={`/assets/${plusImg}.png`} className="sidebar-plus-img" alt="plus" onClick={handlePlusClick} />
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SidebarOption;

